module.exports = __webpack_public_path__ + "img/tuiguang3-3.3d3d0a48.png";